import { useAuthMember, useNetwork } from '@tribeplatform/react-sdk/hooks'

import { useI18n } from '../../i18n/providers/I18nProvider.js'
import { CommandBarHookResult } from '../types.js'

export const useCommandBarNavigation: CommandBarHookResult = () => {
  const { $t } = useI18n()
  const { isGuest, data: member, isLoading } = useAuthMember()
  const { data: network } = useNetwork()

  if (isGuest) {
    return {
      isLoading: false,
      actions: [
        {
          name: 'Log in',
          url: `/auth/login`,
          category: 'General',
          hotkey: 'option+l,alt+l',
        },
      ],
    }
  }

  const { privateMessagingEnabled } = network?.settings?.privateMessaging || {}

  const categoryTexts = {
    navigation: $t({
      id: 'Generics.Navigation',
      defaultMessage: 'Navigation',
    }),
    general: $t({
      id: 'CommandBar.Navigation.General',
      defaultMessage: 'General',
    }),
  } as const

  return {
    isLoading,
    actions: [
      {
        name: $t({
          id: 'CommandBar.Navigation.GoToHome',
          defaultMessage: 'Go to home',
        }),
        url: `/`,
        category: categoryTexts.navigation,
      },
      {
        name: $t({
          id: 'CommandBar.Navigation.GoToMyNotifications',
          defaultMessage: 'Go to my notifications',
        }),
        url: `/notifications`,
        category: categoryTexts.navigation,
      },
      privateMessagingEnabled && {
        name: $t({
          id: 'CommandBar.Navigation.GoToMyMessages',
          defaultMessage: 'Go to my messages',
        }),
        url: `/messaging`,
        category: categoryTexts.navigation,
      },
      {
        name: $t({
          id: 'CommandBar.Navigation.GoToMyProfile',
          defaultMessage: 'Go to my profile',
        }),
        url: `/member/${member?.id}`,
        category: categoryTexts.navigation,
      },
      {
        name: $t({
          id: 'CommandBar.Navigation.GoToMyAccountSettings',
          defaultMessage: 'Go to my account settings',
        }),
        url: `/settings/account`,
        category: categoryTexts.navigation,
      },
      {
        name: $t({
          id: 'CommandBar.Navigation.GoToMyNotificationSettings',
          defaultMessage: 'Go to my notification settings',
        }),
        url: `/settings/notifications`,
        category: categoryTexts.navigation,
      },
      {
        name: $t({
          id: 'Generics.LogOut',
          defaultMessage: 'Log out',
        }),
        url: `/auth/logout`,
        category: categoryTexts.general,
        hotkey: 'option+shift+q,alt+shift+q',
      },
    ],
  }
}
